var ol = require('../dist/ol-debug');
/**
 * Модификация MouseWheelZoom с правкой большой чувствительности зума при использовании тачпада
 * Повторение правок 77f298667e0b 5cd2599ed528 4cfe9e0a3411
 * @param opt_options
 * @constructor
 */
ol.interaction.OMJSMouseWheelZoom = function (opt_options) {
    ol.interaction.MouseWheelZoom.call(this, opt_options);
    this.finishAnchor_ = null;
    this.trackpadTimeoutFinish_ = undefined;
    this._trackpadDeltaBuff = 0;
}
ol.inherits(ol.interaction.OMJSMouseWheelZoom, ol.interaction.MouseWheelZoom);

ol.interaction.OMJSMouseWheelZoom.prototype.handleEvent = function handleEvent(mapBrowserEvent) {
    if (!this.condition_(mapBrowserEvent)) {
        return true;
    }
    var type = mapBrowserEvent.type;
    if (type !== ol.events.EventType.WHEEL && type !== ol.events.EventType.MOUSEWHEEL) {
        return true;
    }

    mapBrowserEvent.preventDefault();

    var map = mapBrowserEvent.map;
    var wheelEvent = /** @type {WheelEvent} */ (mapBrowserEvent.originalEvent);

    if (this.useAnchor_) {
        this.lastAnchor_ = mapBrowserEvent.coordinate;
        this.finishAnchor_ = [mapBrowserEvent.coordinate[0], mapBrowserEvent.coordinate[1]];
    }

    // Delta normalisation inspired by
    // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
    var delta;
    if (mapBrowserEvent.type == ol.events.EventType.WHEEL) {
        delta = wheelEvent.deltaY;
        if (ol.has.FIREFOX &&
            wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
            delta /= ol.has.DEVICE_PIXEL_RATIO;
        }
        if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) {
            delta *= 40;
        }
    } else if (mapBrowserEvent.type == ol.events.EventType.MOUSEWHEEL) {
        delta = -wheelEvent.wheelDeltaY;
        if (ol.has.SAFARI) {
            delta /= 3;
        }
    }

    if (delta === 0) {
        return false;
    }

    var now = Date.now();

    if (this.startTime_ === undefined) {
        this.startTime_ = now;
    }

    if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) {
        this.mode_ = Math.abs(delta) < 8 ?
            ol.interaction.OMJSMouseWheelZoom.Mode_.TRACKPAD :
            ol.interaction.OMJSMouseWheelZoom.Mode_.WHEEL;
    }

    if (this.mode_ === ol.interaction.OMJSMouseWheelZoom.Mode_.TRACKPAD) {
        if ((this._trackpadDeltaBuff < 0 && delta > 0) || (this._trackpadDeltaBuff > 0 && delta < 0)) {
            this._trackpadDeltaBuff = 0;
        }

        this._trackpadDeltaBuff += delta;

        if (Math.abs(this._trackpadDeltaBuff) < 53) {
            return;
        }

        this._trackpadDeltaBuff = 0;

        if (this.trackpadTimeoutFinish_ === undefined) {
            var that = this;
            this.trackpadTimeoutFinish_ = setTimeout(function () {
                that.trackpadTimeoutFinish_ = undefined;
            }, this.duration_);
        } else {
            return;
        }
    }

    this.delta_ += delta;

    var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);

    clearTimeout(this.timeoutId_);
    this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);

    return false;
};
ol.interaction.OMJSMouseWheelZoom.prototype.handleWheelZoom_ = function handleWheelZoom_(map) {
    var view = map.getView();
    if (view.getAnimating()) {
        view.cancelAnimations();
    }
    var maxDelta = ol.interaction.OMJSMouseWheelZoom.MAX_DELTA_;
    var delta = ol.math.clamp(this.delta_, -maxDelta, maxDelta);
    ol.interaction.Interaction.zoomByDelta(view, -delta, this.lastAnchor_, this.duration_);
    view.setHint(ol.ViewHint.INTERACTING, 0);
    this.mode_ = undefined;
    this.delta_ = 0;
    this.lastAnchor_ = null;
    this.startTime_ = undefined;
    this.timeoutId_ = undefined;
};
ol.interaction.OMJSMouseWheelZoom.Mode_ = {
    TRACKPAD: 'trackpad',
    WHEEL: 'wheel'
};
ol.interaction.OMJSMouseWheelZoom.MAX_DELTA_ = 1;



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/mousewheelzoom.js
// module id = 26
// module chunks = 0